export const SET_LOADING = "SET_LOADING";
export const SET_PAGE = "SET_PAGE";
export const SET_PERPAGE = "SET_PERPAGE";
export const SET_TOTAL = "SET_TOTAL";
export const SET_LIST = "SET_LIST";
export const SET_LOAD = "SET_LOAD";
export const SET_FILTER = "SET_FILTER";
export const SET_QTDE_STATUS = "SET_QTDE_STATUS";
export const SET_ITEMS = "SET_ITEMS";
export const SET_ENTREGADORES = "SET_ENTREGADORES";
